import firebase from './firebase';
export * from './api';
export default firebase;
